module.exports = "../images/icons/unchecked-box.svg";